import LoginForm from "../features/login/LoginForm";

const Login = () => {
    return(
        <div className='h-[100vh] flex justify-center items-center bg-whiteBg'>
            <div className='w-[95%] h-[90%] bg-white'>
                <div className='text-base md:text-xl border-b border-b-1 border-b-whiteBg mx-5 py-4 flex justify-center items-center gap-1'>
                    <span>اداره کل امور عشایر خراسان جنوبی</span><img alt='office-icon' className='w-[40px] h-[30px] sm:w-[50px] sm:h-[40px]' src='/Untitled.jpg' />
                </div>
                <div className='mt-5'>
                    <h2 className='inline'>ورود به پنل کاربری</h2>
                    <p className='text-xs sm:text-base mt-1'>خوش آمدید! لطفا با نام کاربری و رمز عبور خود وارد شوید</p>
                </div>
                <LoginForm />
                <p className='text-xs sm:text-sm text-slate-600'>برای کارایی بهتر، از مرورگر <span className='text-blue-600'>گوگل کروم</span> استفاده نمایید</p>
            </div>
        </div>
    )
}

export default Login